module.exports = __webpack_public_path__ + "static/media/ic-info-outline.c7a76ba9.svg";